/**
 * All app routes live under this prefix (no trailing slash).
 */
export const TRAVEL_SERVICES_BASE_PATH = "/financial-services/travel-services";

export const routes = {
    /** Default landing (hub with hero cards). */
    access: `${TRAVEL_SERVICES_BASE_PATH}/access`,
    flights: `${TRAVEL_SERVICES_BASE_PATH}/flights`,
    hotelsAndAttractions: `${TRAVEL_SERVICES_BASE_PATH}/hotels-and-attractions`,
    login: `${TRAVEL_SERVICES_BASE_PATH}/login`,
    creditGuardSuccess: `${TRAVEL_SERVICES_BASE_PATH}/login/credit-guard/success`,
    creditGuardFailure: `${TRAVEL_SERVICES_BASE_PATH}/login/credit-guard/failure`,
} as const;
